import useReviewsPaginationStore from '~/modules/reviews/stores/useReviewsPaginationStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useReviewsPagination = () => passStoreThroughComposableFactory(useReviewsPaginationStore());

export default useReviewsPagination;
